import * as Yup from 'yup';
import { CuffaLandCategoryEnum } from 'interfaces/cuffa.interface';

export const categoriaFundiariaValidationSchema = Yup.object().shape({
    landCategory: Yup.string().required('Campo obrigatório'),

    codigoAssentamento: Yup.string().when('landCategory', {
        is: CuffaLandCategoryEnum.ASSENTAMENTO_FEDERAL_ESTADUAL,
        then: Yup.string()
            .required('Código do assentamento é obrigatório')
            .matches(/^MT\d{8}$/, 'O código deve estar no formato MT00000000'),
        otherwise: Yup.string().notRequired(),
    }),

    nomePncFTerraBrasilBancoDaTerra: Yup.string().when('landCategory', {
        is: CuffaLandCategoryEnum.PNCF_TERRA_BRASIL_BANCO_DA_TERRA,
        then: Yup.string().required('Campo obrigatório'),
        otherwise: Yup.string().notRequired(),
    }),

    nomeComunidadeQuilombola: Yup.string().when('landCategory', {
        is: CuffaLandCategoryEnum.COMUNIDADE_QUILOMBOLA,
        then: Yup.string().required('Campo obrigatório'),
        otherwise: Yup.string().notRequired(),
    }),

    nomeComunidadeTradicional: Yup.string().when('landCategory', {
        is: CuffaLandCategoryEnum.COMUNIDADE_TRADICIONAL,
        then: Yup.string().required('Campo obrigatório'),
        otherwise: Yup.string().notRequired(),
    }),

    nomeTerraIndigena: Yup.string().when('landCategory', {
        is: CuffaLandCategoryEnum.TERRA_INDIGENA,
        then: Yup.string().required('Campo obrigatório'),
        otherwise: Yup.string().notRequired(),
    }),
});

export default categoriaFundiariaValidationSchema;
